import React from 'react';
import Shimmer from '../../common/Shimmer';

const OutOfStockCardShimmer: React.FC = () => {
  return (
    <div className="out-of-stock-card shimmer-card">
      <div className="out-of-stock-header">
        <div className="out-of-stock-title">
          <Shimmer width="18px" height="18px" borderRadius="50%" />
          <Shimmer width="200px" height="20px" />
        </div>
        <Shimmer width="100px" height="36px" className="shimmer-button" />
      </div>

      <div className="out-of-stock-items">
        {[1, 2, 3].map((item) => (
          <div key={item} className="out-of-stock-item">
            <div className="item-info">
              <Shimmer width="40px" height="40px" borderRadius="8px" className="shimmer-image" />
              <div className="item-details">
                <Shimmer width="120px" height="16px" className="shimmer-text" />
                <Shimmer width="80px" height="14px" className="shimmer-text" />
              </div>
            </div>
            
            <div className="item-metrics">
              <div className="item-aov">
                <Shimmer width="80px" height="12px" className="shimmer-text" />
                <Shimmer width="60px" height="16px" className="shimmer-text" />
              </div>
              
              <div className="item-date">
                <Shimmer width="70px" height="12px" className="shimmer-text" />
                <Shimmer width="80px" height="16px" className="shimmer-text" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="out-of-stock-footer">
        <Shimmer width="100px" height="16px" />
      </div>
    </div>
  );
};

export default OutOfStockCardShimmer;
